export type SettlementRequest = {
    fromDate: string;
    toDate: string;
    preAcctYn: string;
};

export type SettlementResponse = {
    riderId: string;
    suppId: string;
    fromDate: string;
    toDate: string;
    preAcctYn: string;
    settlementSummary: SettlementSummary;
    success: boolean;
    message: string;
};

export type SettlementSummary = {
    totDeliveryVal?: number | null;
    totAddVal?: number | null;
    totDeliveryCnt?: number | null;
    totManageVal?: number | null;
    totRiderEmpVal?: number | null;
    totRiderAccidtVal?: number | null;
    totTimeInsurVal?: number | null;
    totWithholdTax?: number | null;
    totDeductVal?: number | null;
    totBalAmt?: number | null;
    totRecoverAmt?: number | null;
    totAcctVal?: number | null;
    totPreAcctVal?: number | null;
    unpaidAmt?: number | null;
    currentUnpaidAmt?: number | null;
    bizName?: string | null;
    deliveryVal?: number | null;
    procCnt?: number | null;
    addAcctVal?: number | null;
    maintncVal?: number | null;
    supplyAmt?: number | null;
    taxVat?: number | null;
    supplyPrice?: number | null;
    manageFee?: number | null;
    achievementPayback?: number | null;
    promotion?: number | null;
    paymentMgmtFee?: number | null;
    deductVal?: number | null;
    suppEmpVal?: number | null;
    suppAccidtVal?: number | null;
    totInsureVal?: number | null;
    insuranceTotal?: number | null;
    acctVal?: number | null;
};

export type SupplierSettlementSummary = {
    bizName: string | null;
    deliveryVal: number | null;
    procCnt: number | null;
    addAcctVal: number | null;
    maintncVal: number | null;
    supplyAmt: number | null;
    taxVat: number | null;
    supplyPrice: number | null;
    manageFee: number | null;
    achievementPayback: number | null;
    promotion: number | null;
    paymentMgmtFee: number | null;
    deductVal: number | null;
    suppEmpVal: number | null;
    suppAccidtVal: number | null;
    totInsureVal: number | null;
    insuranceTotal: number | null;
    acctVal: number | null;
};

export type SettlementStats = {
    totalSettlementAmount: number;
    withdrawalBalance: number;
    deliveryProcessFee: number;
    additionalPayment: number;
    completionCount: number;
    promotion: number;
    operationFee: number;
    employmentInsurance: number;
    industrialAccidentInsurance: number;
    hourlyInsurance: number;
    withholdingTax: number;
    advanceDeduction: number;
    recoveryAmt: number;
    currentUnpaidAmt: number;
    recoverAmt: number;
    advancePayment: number;
};

export type SupplierSettlementStats = {
    bizName: string;
    deliveryVal: number;
    procCnt: number;
    addAcctVal: number;
    maintncVal: number;
    supplyAmt: number;
    taxVat: number;
    supplyPrice: number;
    manageFee: number;
    achievementPayback: number;
    promotion: number;
    paymentMgmtFee: number;
    deductVal: number;
    suppEmpVal: number;
    suppAccidtVal: number;
    totInsureVal: number;
    insuranceTotal: number;
    acctVal: number;
};

export const DEFAULT_SETTLEMENT_STATS: SettlementStats = {
    totalSettlementAmount: 0,
    withdrawalBalance: 0,
    deliveryProcessFee: 0,
    additionalPayment: 0,
    completionCount: 0,
    promotion: 0,
    operationFee: 0,
    employmentInsurance: 0,
    industrialAccidentInsurance: 0,
    hourlyInsurance: 0,
    withholdingTax: 0,
    advanceDeduction: 0,
    recoveryAmt: 0,
    currentUnpaidAmt: 0,
    recoverAmt: 0,
    advancePayment: 0,
};

export const DEFAULT_SUPPLIER_SETTLEMENT_STATS: SupplierSettlementStats = {
    bizName: '',
    deliveryVal: 0,
    procCnt: 0,
    addAcctVal: 0,
    maintncVal: 0,
    supplyAmt: 0,
    taxVat: 0,
    supplyPrice: 0,
    manageFee: 0,
    achievementPayback: 0,
    promotion: 0,
    paymentMgmtFee: 0,
    deductVal: 0,
    suppEmpVal: 0,
    suppAccidtVal: 0,
    totInsureVal: 0,
    insuranceTotal: 0,
    acctVal: 0,
};
